import { render, staticRenderFns } from "./TiptapMessageField.vue?vue&type=template&id=2bd1f518"
import script from "./TiptapMessageField.vue?vue&type=script&setup=true&lang=ts"
export * from "./TiptapMessageField.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TiptapMessageField.vue?vue&type=style&index=0&id=2bd1f518&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports